module.exports = __webpack_public_path__ + "static/overlay-header-dont-7dc5f6396f1c249a222d416bde7337c1.png";